module.exports = __webpack_public_path__ + "static/media/CheckboxChecked.811132ab.svg";